import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Faq, { faqJsonLd } from './Faq';
import Seo from './Seo';
import { useFaqGroupes } from '../utils/faq';
import { useLifeEvents, CARTES_PATH } from '../utils/lifeEvents';
import { MINISITE_HUB_PATH } from '../utils/minisiteOccasions';
import { useT, useLang } from '../i18n';

// Page « Questions fréquentes » : toutes les questions de faq.json, par thème. Garde l'adresse
// historique de la FAQ des cartes à gratter (référencée, liée depuis l'accueil et le menu).
// Textes de la page : locales/<langue>/faq-page.json ; questions, réponses et titres de groupes : espace « faq ».
const FaqPage = () => {
  const t = useT('faq-page');
  const { lang } = useLang();
  const groupes = useFaqGroupes(); // groupes de questions dans la langue courante
  const LIFE_EVENTS = useLifeEvents(); // événements de vie dans la langue courante (libellés)
  return (
    <Box sx={{ padding: { xs: 1, sm: 3 } }}>
      <Seo
        titre={t('faq-page.seoTitle')}
        description={t('faq-page.seoDescription')}
        path="/carte-a-gratter-digitale-questions-frequentes"
      />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd(groupes.flatMap((g) => g.questions), lang))}</script>
      </Helmet>
      <Typography variant="h1" sx={{ textAlign: 'center', marginBottom: 2 }}>{t('faq-page.title')}</Typography>
      <Typography sx={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
        {t.rich('faq-page.intro', {}, {
          invitations: <Link to={MINISITE_HUB_PATH} />,
          cards: <Link to={CARTES_PATH} />,
          contact: <Link to="/contact" />,
        })}
      </Typography>
      {groupes.map((groupe) => (
        <Faq key={groupe.id} items={groupe.questions} titre={groupe.titre} balise={false} />
      ))}
      <Typography sx={{ maxWidth: 820, margin: '40px auto 0' }}>
        {t('faq-page.byEvent')} {LIFE_EVENTS.map((event, index) => (
          <React.Fragment key={event.key}>{index > 0 && ' · '}<Link to={event.path}>{event.label}</Link></React.Fragment>
        ))}
      </Typography>
    </Box>
  );
};

export default FaqPage;
